import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { push as routerPush } from '@lagunovsky/redux-react-router';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { locationSelector } from '../_selectors/location.selector';
import { RouterAction } from '../router.action';

type IState =
  & IGetSelectorStateType<typeof locationSelector>;

export const pushEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(RouterAction.push),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const [to, locationState] = payload;
    const location = locationSelector(state);

    if (typeof to === 'string') {
      return [
        routerPush({
          ...location,
          pathname: to,
        }, locationState),
      ];
    }

    return [
      routerPush(to, locationState),
    ];
  }),
);
